import { PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useWarehouseOperationsHeader } from '@app/pages/Warehouses/WarehouseOperations/hooks';

import type { FC } from 'react';

export const WarehouseOperationsHeader: FC = () => {
  const { handleMenuClick, items } = useWarehouseOperationsHeader();

  const { isMobile } = useWindowSize();

  return (
    <Dropdown
      menu={{ items, onClick: handleMenuClick }}
      placement="bottomRight"
    >
      <Button
        className={isMobile ? 'full-width' : ''}
        type="primary"
        icon={<PlusOutlined />}
      >
        Добавить
      </Button>
    </Dropdown>
  );
};
